import { SVGProps } from '@components/Icon/types';

export const Upload = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3.3, 3.3)">
      <path
        d="M16.7002 9.99929C17.0867 9.9993 17.4003 10.313 17.4004 10.6995V16.1995C17.4004 17.1384 16.6391 17.8997 15.7002 17.8997H1.7002C0.761315 17.8997 6.69955e-06 17.1384 0 16.1995V10.6995C0.000133023 10.313 0.313678 9.99929 0.700195 9.99929C1.08671 9.9993 1.40026 10.313 1.40039 10.6995V16.1995C1.4004 16.3652 1.53451 16.4993 1.7002 16.4993H15.7002C15.8659 16.4993 16 16.3652 16 16.1995V10.6995C16.0001 10.313 16.3137 9.99929 16.7002 9.99929Z"
        fill={fill}
      />
      <path
        d="M8.21191 0.167259C8.38297 0.0213729 8.60671 -0.0290711 8.81445 0.0158922C8.93183 0.0412115 9.03861 0.0960667 9.12598 0.172142L13.1504 3.54714C13.4459 3.79563 13.4844 4.23651 13.2363 4.53249C12.9879 4.82839 12.5461 4.8675 12.25 4.61941L9.36621 2.20046V12.6165C9.36595 13.0028 9.05241 13.3166 8.66602 13.3167C8.27976 13.3165 7.96706 13.0027 7.9668 12.6165V2.21706L5.1543 4.6155C4.86033 4.86609 4.41888 4.83102 4.16797 4.53738C3.91713 4.24336 3.95223 3.802 4.24609 3.55105L8.21191 0.167259Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'upload';
